/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEftFileNumber.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/eft-file-number";

export class AutogenModelEftFileNumber<RowType extends ModelRow> extends Endpoint<RowType, RowEftFileNumberFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEftFileNumber extends ModelRow<RowEftFileNumberFields> {
	constructor(values?: Partial<RowEftFileNumberFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEftFileNumberFields {
	company_id: string;
	currency_type: string;
	eft_file_number: number;
	originator_id: string;
}

